(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  })();

  let productCards = document.querySelectorAll(".product-card");
  productCards.forEach((productCard) => {
    productCard.addEventListener("mouseenter", function(e)
    {
      let card = e.currentTarget;
      let videoElement = card.querySelector("video");
      if (videoElement)
      {
        videoElement.play();
      }
    });

    productCard.addEventListener("mouseleave", function(e)
    {
      let card = e.currentTarget;
      let videoElement = card.querySelector("video");
      if (videoElement)
      {
        videoElement.pause();
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderNav {
    constructor() {
      this.header = document.querySelector('[data-header]');
      if (!this.header) return;

      // Mobile elements
      this.mobileToggle = this.header.querySelector('[data-mobile-toggle]');
      this.mobileNav = this.header.querySelector('[data-mobile-nav]');
      this.mobileExpandables = this.header.querySelectorAll('[data-mobile-expandable]');

      // Desktop elements
      this.navTriggers = this.header.querySelectorAll('[data-nav-trigger]');
      this.megamenu = this.header.querySelector('[data-megamenu]');
      this.megamenuPanels = this.header.querySelectorAll('[data-panel]');
      this.desktopOverlay = this.header.querySelector('[data-desktop-overlay]');
      this.cartIcon = this.header.querySelector('[data-cart-icon]');

      // Breakpoint for desktop
      this.desktopBreakpoint = 768;

      // State
      this.isMobileOpen = false;
      this.activePanel = null;

      this.init();
    }

    init() {
      this.initMobileNav();
      this.initDesktopNav();
      this.initResizeHandler();
      this.initScrollHandler();
      this.equalizePanelHeights();
    }

    /* ============================================
       Equalize Megamenu Panel Heights
       ============================================ */
    equalizePanelHeights() {
      if (window.innerWidth < this.desktopBreakpoint) return;
      
      // Reset heights first
      this.megamenuPanels.forEach(panel => {
        panel.style.minHeight = '';
      });

      // Measure all panels (temporarily show them)
      let maxHeight = 0;
      this.megamenuPanels.forEach(panel => {
        panel.style.display = 'block';
        panel.style.visibility = 'hidden';
        panel.style.position = 'absolute';
        const height = panel.offsetHeight;
        if (height > maxHeight) maxHeight = height;
        panel.style.display = '';
        panel.style.visibility = '';
        panel.style.position = '';
      });

      // Apply max height to all panels
      if (maxHeight > 0) {
        this.megamenuPanels.forEach(panel => {
          panel.style.minHeight = `${maxHeight}px`;
        });
      }
    }

    /* ============================================
       Mobile Navigation
       ============================================ */
    initMobileNav() {
      this.mobileToggle?.addEventListener('click', () => this.toggleMobileNav());

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isMobileOpen) {
          this.closeMobileNav();
        }
      });

      this.mobileExpandables.forEach(item => {
        const button = item.querySelector('button');
        button?.addEventListener('click', () => this.toggleMobileExpandable(item, button));
      });
    }

    toggleMobileNav() {
      this.isMobileOpen ? this.closeMobileNav() : this.openMobileNav();
    }

    openMobileNav() {
      this.isMobileOpen = true;
      this.header.classList.remove('header--hidden');
      this.header.classList.add('header--mobile-open');
      this.mobileToggle?.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => this._syncMobileNavTopOffset?.());
    }

    closeMobileNav() {
      this.isMobileOpen = false;
      this.header.classList.remove('header--mobile-open');
      this.mobileToggle?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      this.mobileToggle?.focus();
    }

    toggleMobileExpandable(item, button) {
      const isExpanded = item.hasAttribute('data-expanded');
      if (isExpanded) {
        item.removeAttribute('data-expanded');
        button?.setAttribute('aria-expanded', 'false');
      } else {
        this.mobileExpandables.forEach((other) => {
          if (other === item) return;
          other.removeAttribute('data-expanded');
          other.querySelector('button')?.setAttribute('aria-expanded', 'false');
        });
        item.setAttribute('data-expanded', '');
        button?.setAttribute('aria-expanded', 'true');
      }
    }

    /* ============================================
       Desktop Navigation (Hover-based Megamenu)
       ============================================ */
    initDesktopNav() {
      this.hoverTimeout = null;
      this.closeTimeout = null;

      this.navTriggers.forEach(trigger => {
        const navItem = trigger.closest('[data-nav-item]');
        const panelId = navItem?.dataset.navItem;

        // Open on hover
        navItem?.addEventListener('mouseenter', () => {
          if (window.innerWidth >= this.desktopBreakpoint) {
            clearTimeout(this.closeTimeout);
            this.hoverTimeout = setTimeout(() => {
              this.openPanel(panelId, trigger);
            }, 50); // Small delay to prevent accidental triggers
          }
        });

        // Close when leaving nav item (unless entering megamenu)
        navItem?.addEventListener('mouseleave', () => {
          clearTimeout(this.hoverTimeout);
        });

        // Also support click for accessibility
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          if (window.innerWidth >= this.desktopBreakpoint) {
            this.togglePanel(panelId, trigger);
          }
        });

        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeAllPanels();
            trigger.focus();
          }
        });
      });

      // Keep open when hovering megamenu
      this.megamenu?.addEventListener('mouseenter', () => {
        clearTimeout(this.closeTimeout);
      });

      // Close when leaving megamenu
      this.megamenu?.addEventListener('mouseleave', () => {
        this.closeTimeout = setTimeout(() => {
          this.closeAllPanels();
        }, 100);
      });

      // Close when leaving the entire header area (but not if going to announcement bar)
      this.header.addEventListener('mouseleave', (e) => {
        if (window.innerWidth >= this.desktopBreakpoint) {
          // Check if mouse is going to announcement bar - don't close
          const announcementBar = document.querySelector('.announcement-bar');
          if (announcementBar && announcementBar.contains(e.relatedTarget)) {
            return;
          }
          this.closeTimeout = setTimeout(() => {
            this.closeAllPanels();
          }, 150);
        }
      });

      // Cancel close if re-entering header
      this.header.addEventListener('mouseenter', () => {
        clearTimeout(this.closeTimeout);
      });

      // Also cancel close if hovering announcement bar
      const announcementBar = document.querySelector('.announcement-bar');
      announcementBar?.addEventListener('mouseenter', () => {
        clearTimeout(this.closeTimeout);
      });

      // Close when clicking or hovering overlay
      this.desktopOverlay?.addEventListener('click', () => {
        this.closeAllPanels();
      });

      this.desktopOverlay?.addEventListener('mouseenter', () => {
        this.closeAllPanels();
      });

      // Close when clicking outside
      document.addEventListener('click', (e) => {
        if (window.innerWidth >= this.desktopBreakpoint) {
          if (!this.header.contains(e.target)) {
            this.closeAllPanels();
          }
        }
      });
    }

    togglePanel(panelId, trigger) {
      if (this.activePanel === panelId) {
        this.closeAllPanels();
      } else {
        this.openPanel(panelId, trigger);
      }
    }

    openPanel(panelId, trigger) {
      // Reset all triggers
      this.navTriggers.forEach(t => t.setAttribute('aria-expanded', 'false'));

      // Hide all panels
      this.megamenuPanels.forEach(p => p.classList.remove('is-active'));

      // Show target panel
      const targetPanel = this.header.querySelector(`[data-panel="${panelId}"]`);
      if (targetPanel) {
        targetPanel.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        this.header.classList.add('header--megamenu-open');
        this.activePanel = panelId;
      }
    }

    closeAllPanels() {
      this.navTriggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
      this.megamenuPanels.forEach(p => p.classList.remove('is-active'));
      this.header.classList.remove('header--megamenu-open');
      this.activePanel = null;
    }

    /* ============================================
       Scroll Handler
       ============================================ */
    initScrollHandler() {
      this.initMobileScrollHandler();
      this.initScrollDirectionHandler();
    }

    initMobileScrollHandler() {
      const container = this.header.querySelector('.header__container');
      if (!container) return;

      const announcementBar = document.querySelector('.announcement-bar');
      const baseOffset = 13;
      let ticking = false;

      /**
       * Pill margin + drawer top inset — must track scroll when the announcement
       * bar moves so the fixed nav stays aligned.
       */
      const syncMobileChrome = () => {
        if (window.innerWidth >= this.desktopBreakpoint) {
          container.style.removeProperty('--nav-top-offset');
          this.header.style.removeProperty('--mobile-nav-inner-padding-top');
          ticking = false;
          return;
        }
        if (announcementBar) {
          const abBottom = Math.max(0, announcementBar.getBoundingClientRect().bottom);
          container.style.setProperty('--nav-top-offset', (baseOffset + abBottom) + 'px');
        } else {
          container.style.removeProperty('--nav-top-offset');
        }
        const chromeBottom = container.getBoundingClientRect().bottom;
        this.header.style.setProperty('--mobile-nav-inner-padding-top', `${chromeBottom}px`);
        ticking = false;
      };

      /**
       * Page body padding uses --sticky-header-offset. Updating that on every
       * scroll reflows the document and makes scrolling feel broken — only sync
       * on load / resize / first paint (and desktop cleanup).
       */
      const syncPageContentHeaderInset = () => {
        const root = document.documentElement;
        if (window.innerWidth >= this.desktopBreakpoint) {
          root.style.removeProperty('--sticky-header-offset');
          return;
        }
        root.style.setProperty(
          '--sticky-header-offset',
          `${container.getBoundingClientRect().bottom}px`
        );
      };

      const syncAllMobileHeaderLayout = () => {
        syncMobileChrome();
        syncPageContentHeaderInset();
      };

      this._syncMobileNavTopOffset = syncAllMobileHeaderLayout;

      if (announcementBar) {
        window.addEventListener('scroll', () => {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(syncMobileChrome);
          }
        }, { passive: true });
      }

      /* Match CSS fallback immediately: scroll handler was the only place this
         ran before, so first paint used --announcement-bar-height while any
         real bar height / wrapping differed from that token. */
      requestAnimationFrame(syncAllMobileHeaderLayout);
      window.addEventListener('load', () => requestAnimationFrame(syncAllMobileHeaderLayout), { once: true });
    }

    initScrollDirectionHandler() {
      let lastScrollY = window.scrollY;
      let lastDirection = null;
      let scrollAccumulator = 0;
      let ticking = false;
      
      const updateHeaderVisibility = () => {
        const isMobile = window.innerWidth < this.desktopBreakpoint;
        // Aggressive hide thresholds — the previous 80px desktop /
        // 60px mobile gates required a noticeable amount of scroll
        // before the header would dismiss, which on long pages (PDP,
        // editorial content) meant the fixed header lingered over
        // newly-revealed content. Tighter values dismiss the header
        // almost immediately on any sustained downward scroll while
        // still letting tiny scroll jitters keep it pinned.
        const hideThreshold = isMobile ? 24 : 32;
        const showThreshold = isMobile ? 16 : 20;
        const topThreshold = isMobile ? 40 : 60;
        
        if (this.isMobileOpen) {
          ticking = false;
          return;
        }
        
        const currentScrollY = window.scrollY;
        const scrollDelta = currentScrollY - lastScrollY;
        const direction = scrollDelta > 0 ? 'down' : scrollDelta < 0 ? 'up' : lastDirection;
        
        if (currentScrollY > 20) {
          this.header.classList.add('header--scrolled');
        } else {
          this.header.classList.remove('header--scrolled');
        }

        if (currentScrollY < topThreshold) {
          this.header.classList.remove('header--hidden');
          scrollAccumulator = 0;
          lastDirection = null;
          lastScrollY = currentScrollY;
          ticking = false;
          return;
        }
        
        if (this.activePanel) {
          lastScrollY = currentScrollY;
          ticking = false;
          return;
        }
        
        if (direction !== lastDirection) {
          scrollAccumulator = 0;
          lastDirection = direction;
        }
        
        scrollAccumulator += Math.abs(scrollDelta);
        
        if (direction === 'down' && scrollAccumulator > hideThreshold) {
          this.header.classList.add('header--hidden');
        } else if (direction === 'up' && scrollAccumulator > showThreshold) {
          this.header.classList.remove('header--hidden');
        }
        
        lastScrollY = currentScrollY;
        ticking = false;
      };

      window.addEventListener('scroll', () => {
        if (!ticking) {
          requestAnimationFrame(updateHeaderVisibility);
          ticking = true;
        }
      }, { passive: true });
    }

    /* ============================================
       Resize Handler
       ============================================ */
    initResizeHandler() {
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (window.innerWidth >= this.desktopBreakpoint && this.isMobileOpen) {
            this.closeMobileNav();
          }
          if (window.innerWidth < this.desktopBreakpoint && this.activePanel) {
            this.closeAllPanels();
          }
          this.equalizePanelHeights();
          this._syncMobileNavTopOffset?.();
        }, 100);
      });
    }
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new HeaderNav());
  } else {
    new HeaderNav();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel {
    constructor() {
      this.hero = document.querySelector('[data-hero]');
      if (!this.hero) return;

      this.carousel = this.hero.querySelector('[data-hero-carousel]');
      this.slides = this.hero.querySelectorAll('[data-hero-slide]');
      this.dots = this.hero.querySelectorAll('[data-hero-dot]');

      this.current = 0;
      this.total = this.slides.length;
      this.autoplayInterval = 8000;
      this.timer = null;

      // Swipe state
      this.swipeThreshold = 40;        // px of horizontal travel before it counts
      this.directionLockSlop = 10;     // px before deciding swipe vs vertical scroll
      this.pointerStartX = 0;
      this.pointerStartY = 0;
      this.isDragging = false;
      this.suppressedNativeScroll = false;

      // Pause every video except the first slide's so they don't all
      // start streaming on page load. The first slide auto-plays via
      // the `autoplay` attribute on the mux-player.
      this.slides.forEach((slide, i) => {
        if (i === 0) return;
        const video = slide.querySelector('.mux-loop');
        if (video && video.pause) {
          try { video.pause(); } catch (_) {}
        }
      });

      // Carousel-only behavior (multi-slide). Even with one slide, we
      // still ran the pause sweep above so that single video plays cleanly.
      if (this.slides.length <= 1) return;

      this.init();
    }

    init() {
      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.heroDot, 10));
          this.resetAutoplay();
        });
      });

      this.bindSwipe();
      this.startAutoplay();
    }

    bindSwipe() {
      if (!this.carousel) return;

      // Belt-and-suspenders: also block native drag at the element level
      // (CSS handles it visually; this stops the drag event from firing).
      this.slides.forEach(slide => {
        slide.querySelectorAll('img').forEach(img => {
          img.setAttribute('draggable', 'false');
          img.addEventListener('dragstart', e => e.preventDefault());
        });
      });

      // Pointer Events unify mouse + touch + pen. Modern browsers all
      // support this — no need for a separate touchstart codepath.
      this.carousel.addEventListener('pointerdown', this.onPointerDown.bind(this));
      this.carousel.addEventListener('pointermove', this.onPointerMove.bind(this));
      this.carousel.addEventListener('pointerup', this.onPointerEnd.bind(this));
      this.carousel.addEventListener('pointercancel', this.onPointerEnd.bind(this));
    }

    onPointerDown(e) {
      // Only primary pointer (left mouse button or touch). Ignore right-clicks.
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      this.isDragging = true;
      this.suppressedNativeScroll = false;
      this.pointerStartX = e.clientX;
      this.pointerStartY = e.clientY;
    }

    onPointerMove(e) {
      if (!this.isDragging) return;
      const dx = e.clientX - this.pointerStartX;
      const dy = e.clientY - this.pointerStartY;
      // Once we know the gesture is predominantly horizontal, claim it
      // (preventDefault) so the page doesn't try to scroll vertically.
      if (
        !this.suppressedNativeScroll &&
        Math.abs(dx) > this.directionLockSlop &&
        Math.abs(dx) > Math.abs(dy)
      ) {
        this.suppressedNativeScroll = true;
      }
      if (this.suppressedNativeScroll && e.cancelable) {
        e.preventDefault();
      }
    }

    onPointerEnd(e) {
      if (!this.isDragging) return;
      this.isDragging = false;
      const dx = e.clientX - this.pointerStartX;
      const dy = e.clientY - this.pointerStartY;
      // Real swipe = past threshold, mostly horizontal. Otherwise treat as a tap.
      if (Math.abs(dx) >= this.swipeThreshold && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) this.next();
        else this.prev();
        this.resetAutoplay();
      }
    }

    prev() {
      this.goTo((this.current - 1 + this.total) % this.total);
    }

    goTo(index) {
      this.current = index;

      this.slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.classList.toggle('hero__slide--active', isActive);

        // Sync video playback to slide visibility — only the active
        // slide's video should be playing. Restart from frame 0 so the
        // user always sees the loop begin when the slide takes focus.
        const video = slide.querySelector('.mux-loop');
        if (video) {
          if (isActive) {
            video.muted = true;
            try { video.currentTime = 0; } catch (_) {}
            const p = video.play && video.play();
            if (p && p.catch) p.catch(() => {});
          } else if (video.pause) {
            try { video.pause(); } catch (_) {}
          }
        }
      });

      this.dots.forEach(dot => {
        dot.classList.toggle('hero__dot--active', parseInt(dot.dataset.heroDot, 10) === index);
      });
    }

    next() {
      this.goTo((this.current + 1) % this.total);
    }

    startAutoplay() {
      this.timer = setInterval(() => this.next(), this.autoplayInterval);
    }

    resetAutoplay() {
      clearInterval(this.timer);
      this.startAutoplay();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new HeroCarousel());
  } else {
    new HeroCarousel();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-science"] && !Shopify.designMode) return;
  try {
    
  class PillarSpotlight {
    constructor() {
      this.section = document.querySelector('.hp-science');
      if (!this.section) return;

      this.modal = this.section.querySelector('[data-pillar-modal]');
      this.titleEl = this.modal?.querySelector('[data-modal-title]');
      this.textEl = this.modal?.querySelector('[data-modal-text]');
      this.text2El = this.modal?.querySelector('[data-modal-text2]');
      this.dots = this.modal?.querySelectorAll('[data-modal-dot]');
      this.triggers = this.section.querySelectorAll('[data-pillar-trigger]');
      this.pillars = [];
      this.current = 0;

      this.triggers.forEach(trigger => {
        const block = trigger.closest('[data-shopify-editor-block]') || trigger;
        const tagText = block.querySelector('[data-pillar-tag]')?.dataset.pillarTag?.trim() || '';
        this.pillars.push({
          modalHeading: trigger.dataset.modalHeading?.trim() || tagText,
          tag: tagText,
          text: block.querySelector('.hp-science__pillar-text')?.textContent.trim() || '',
          modalText: trigger.dataset.modalText || '',
          modalText2: trigger.dataset.modalText2 || ''
        });
      });

      this.init();
    }

    init() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          this.open(parseInt(trigger.dataset.pillarTrigger, 10));
        });
      });

      this.modal?.querySelectorAll('[data-pillar-modal-close]').forEach(el => {
        el.addEventListener('click', () => this.close());
      });

      this.dots?.forEach(dot => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.modalDot, 10));
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal?.classList.contains('is-open')) {
          this.close();
        }
      });
    }

    open(index) {
      this.goTo(index);
      this.modal.classList.add('is-open');
      // Lock background scroll while the pillar modal is open. Mirrors the
      // pattern used by the product-hero lightbox and testimonial lightbox
      // so the page can't scroll behind a fullscreen overlay.
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    goTo(index) {
      this.current = index;
      const pillar = this.pillars[index];
      if (!pillar) return;

      if (this.titleEl) this.titleEl.textContent = pillar.modalHeading || pillar.tag;
      if (this.textEl) this.textEl.textContent = pillar.modalText || pillar.text;
      if (this.text2El) this.text2El.textContent = pillar.modalText2;

      this.dots?.forEach(dot => {
        dot.classList.toggle('hp-science__modal-dot--active', parseInt(dot.dataset.modalDot, 10) === index);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new PillarSpotlight());
  } else {
    new PillarSpotlight();
  }

  /* Signs "gif-style" Mux video: restart from frame 0 whenever it scrolls
     into view and pause when it leaves, so the loop always begins cleanly
     for the viewer. Autoplay/muted/loop are handled by the mux-video-loop
     snippet; this just owns the in-view restart. */
  (function () {
    var stages = document.querySelectorAll('[data-signs-video]');
    if (!stages.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('.mux-loop');
        if (!video) return;
        if (entry.isIntersecting) {
          try {
            video.muted = true;
            video.currentTime = 0;
            var p = video.play && video.play();
            if (p && p.catch) p.catch(function () {});
          } catch (_) {}
        } else {
          try { video.pause(); } catch (_) {}
        }
      });
    }, { threshold: 0.25 });

    stages.forEach(function (s) { io.observe(s); });
  })();

  } catch(e) { console.error(e); }
})();
})();
